module.exports = __webpack_public_path__ + "img/Strategies_2.d90a185f.png";